module.exports = __webpack_public_path__ + "img/image (37).42422a90.jpg";